// Dashboard & analytics routes
import AdminDashboard from '../../views/DashboardView.vue'
import UserProfile from '../../views/Profile.vue'
import UserAnalytics from '../../views/Analytics.vue'
import VideoAnalytics from '../../views/VideoAnalytics.vue'
import FilesList from '../../components/FilesList.vue'

export default [
  {
    path: '/dashboard',
    name: 'Dashboard',
    component: AdminDashboard,
    meta: { 
      requiresAuth: true,
      title: 'Dashboard'
    }
  },
  {
    path: '/analytics',
    name: 'Analytics',
    component: UserAnalytics,
    meta: { 
      requiresAuth: true,
      title: 'User Analytics'
    }
  },
  {
    path: '/video-analytics',
    name: 'VideoAnalytics',
    component: VideoAnalytics,
    meta: { 
      requiresAuth: true,
      title: 'Video Analytics'
    }
  },
  {
    path: '/profile',
    name: 'Profile',
    component: UserProfile,
    meta: { 
      requiresAuth: true,
      title: 'My Profile'
    }
  },
  {
    path: '/files',
    name: 'FilesList',
    component: FilesList,
    meta: { 
      requiresAuth: true,
      title: 'Files List'
    }
  }
] 